import "./togglebutton.css";
import { useState, useEffect, useLayoutEffect } from "react";

const DeliverToggle = ({ toggleValue, updatetoggle }) => {
  const [toggle, setToggle] = useState(null);
  const [transform, setTransform] = useState("0px");
  let backGroundColor = toggle ? /* "#54E346" */ "rgb(106 157 207)" : "rgb(199, 205, 216)";

  useLayoutEffect(() => {
    console.log(toggleValue);
    setToggle(toggleValue);
    //handleToggle()
    toggleValue
      ? /*  (document.querySelector(".tbuttonD").style.transform = "translateX(25px)") */ setTransform("25px")
      : /* (document.querySelector(".tbuttonD").style.transform = "translateX(0px)") */ setTransform("0px");
  }, []);
  useLayoutEffect(() => {
    setToggle(toggleValue);
    //handleToggle()
    toggleValue
      ? /*  (document.querySelector(".tbuttonD").style.transform = "translateX(25px)") */ setTransform("25px")
      : /* (document.querySelector(".tbuttonD").style.transform = "translateX(0px)") */ setTransform("0px");
  }, [toggleValue]);

  useEffect(() => {
    updatetoggle(toggle);
    console.log("toggle", toggle);
  }, [toggle]);

  const handleToggle = (e) => {
    let target = e.target;
    if (toggle) {
      target.style.transform = "translateX(0px)";
      setToggle(false);
    } else {
      target.style.transform = "translateX(25px)";
      setToggle(true);
    }
  };

  return (
    <>
      <div style={{ backgroundColor: backGroundColor }} className='toggleButtonD'>
        <div onClick={(e) => handleToggle(e)} className='tbuttonD' style={{ transform: `translateX(${transform})` }}></div>
      </div>
    </>
  );
};

export default DeliverToggle;

export const ProductDeliverToggle = ({ toggleValue, updatetoggle, removeDelivData }) => {
  const [toggle, setToggle] = useState(null);
  const [transform, setTransform] = useState("0px");
  let backGroundColor = toggle ? /* "#54E346" */ "rgb(106 157 207)" : "rgb(199, 205, 216)";
  useLayoutEffect(() => {
    console.log(toggleValue);
    setToggle(toggleValue);
    //handleToggle()
    toggleValue ? setTransform("25px") : setTransform("0px");
  }, []);

  const handleToggle = (e) => {
    let target = e.target;
    if (toggle) {
      target.style.transform = "translateX(0px)";
      setToggle(false);
      removeDelivData((prev) => ({ ...prev, deliveryTime: "", deliveryFee: "" }));
    } else {
      target.style.transform = "translateX(25px)";
      setToggle(true);
    }
  };
  useEffect(() => {
    updatetoggle(toggle);
  }, [toggle]);
  return (
    <>
      <div style={{ backgroundColor: backGroundColor }} className='toggleButtonD'>
        <div onClick={(e) => handleToggle(e)} className='tbuttonD' style={{ transform: `translateX(${transform})` }}></div>
      </div>
    </>
  );
};
export const SubscriptionToggle = ({ toggleValue, updatetoggle, removeDelivData }) => {
  const [toggle, setToggle] = useState(null);
  const [transform, setTransform] = useState("0px");
  let backGroundColor = toggle === "monthly" ? "rgb(86, 137, 55)" : /* "#54E346" */ "rgb(106 157 207)";
  useLayoutEffect(() => {
    console.log(toggleValue);
    setToggle(toggleValue);
    //handleToggle()
    toggleValue !== "monthly" ? setTransform("25px") : setTransform("0px");
  }, []);

  const handleToggle = (e) => {
    let target = e.target;
    if (toggle === "halfYearly") {
      target.style.transform = "translateX(0px)";
      setToggle("monthly");
    } else {
      target.style.transform = "translateX(25px)";
      setToggle("halfYearly");
    }
  };
  useEffect(() => {
    updatetoggle(toggle);
  }, [toggle]);
  return (
    <>
      <div style={{ backgroundColor: backGroundColor }} className='toggleButtonD'>
        <div onClick={(e) => handleToggle(e)} className='tbuttonD' style={{ transform: `translateX(${transform})` }}></div>
      </div>
    </>
  );
};
